var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.schema),function(item,index){return _c(item.type,{key:index,tag:"component",attrs:{"content":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }